import React, { useState } from "react";
import Sidebar from "../include/Sidebar";
import NavHeader from "../include/NavHeader";

interface Props {
  children: JSX.Element | string;
  pageName: string;
}

const WebLayout: React.FC<Props> = ({ children, pageName }) => {
  const [isMobileToggle, setMobileToggle] = useState<any>("off");
  const [activeMenu, setActiveMenu] = useState<any>(null);

  return (
    <>
      <div
        className={`layout-wrapper layout-content-navbar ${
          isMobileToggle === "on" ? "layout-menu-expanded" : ""
        }`}
      >
        {" "}
        <div className="layout-container">
          <Sidebar
            setMobileToggle={setMobileToggle}
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
          />

          <div className="layout-page">
            <NavHeader
              setMobileToggle={setMobileToggle}
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
            />

            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default WebLayout;
